












































































































































import {Component, Vue} from 'vue-property-decorator';
import MemberOperations from '@/components/member/MemberOperations.vue';
import Tutorial from '@/components/member/Tutorial.vue';
import ViewBase from '@/views/ViewBase';
import MemberApi from '@/apis/MemberApi';

@Component({
  name: 'App',
  components: {
    MemberOperations,
    Tutorial,
  },
})
export default class App extends ViewBase {

    public showMemberDrawer: boolean = false;
    public showSignOutDialog: boolean = false;
    public cookieChip = true;

    public get showTutorial(): boolean {
      return this.$store.state.showTutorial;
    }

    public get showSnackbar(): boolean {
      return this.$store.state.showSnackbar;
    }

    public set showSnackbar(value: boolean) {
      this.$store.commit('mutateShowSnackbar', value);
    }

    public get snackbarText(): string {
      return this.$store.state.snackbarText;
    }

    public set snackbarText(value: string) {
      this.$store.commit('mutateSnackbarText', value);
    }

    public get isMemberAuthenticated(): boolean {
      return this.$store.state.member.authenticated;
    }

    public get showSessionExpiringDialog(): boolean {
      return this.$store.state.showSessionExpiringDialog;
    }

    public signOutClick() {
      this.showSignOutDialog = true;
    }

    public signOutDialogNo() {
      this.showSignOutDialog = false;
    }

    public async signOutDialogYesAsync() {
      this.showSignOutDialog = false;
      this.showMemberDrawer = false;
      await this.signOutAsync();
    }

    public snackbarCloseClick() {
      this.$store.commit('mutateShowSnackbar', false);
      this.$store.commit('mutateSnackbarText', '');
    }

    public sessionExpiringDialogNo() {
      this.$store.commit('mutateShowSessionExpiringDialog', false);
    }

    public async sessionExpiringDialogYesAsync() {
      try {
          this.resetProcessingValues();

          const api = new MemberApi();
          const response = await api.refreshTokenAsync(this.$store.state.member.jwt);

          this.$store.commit('mutateMemberJwt', response.jwt);

          this.$store.dispatch('refreshJwtExpirationTimer', response.jwtExpirationMs);
          this.$store.commit('mutateShowSessionExpiringDialog', false);
      }
      catch ( err ) {
          await this.handleProcessingErrorAsync(err);
      }
      finally {
          this.processing = false;
      }
    }
}

